import { render, staticRenderFns } from "./user-test-training.vue?vue&type=template&id=164a4b07"
import script from "./user-test-training.vue?vue&type=script&lang=js"
export * from "./user-test-training.vue?vue&type=script&lang=js"
import style0 from "./user-test-training.vue?vue&type=style&index=0&id=164a4b07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports